<template>
  <div>
    <vs-card>
      <b-row align-v="center">
        <b-col cols="3">
          <v-select v-model="excelSablon" :options="sablonOptions" label="name" autocomplete name="name"
            v-validate="'required'">
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('name')">{{
            errors.first("name")
          }}</span>
        </b-col>
        <!--
        <b-col cols="3" v-if="excelSablon.name == 'Dropshipping'">
          <vs-input
            size="small"
            v-model="orderSource"
            type="text"
            class="w-full"
            name="companyName"
            v-validate="'required'"
            placeholder="Program"
          />
        </b-col>-->
        <b-col v-if="excelSablon" cols="2">
          Örnek Excel Şablonu
          <a :href="'http://sistem.uzum.com.tr/assets/' + excelSablon.excel" download>İNDİR</a>
        </b-col>
        <b-col v-if="excelSablon" cols="2">
          <input type="file" @change="onChange" /></b-col>
        <b-col style="text-align: center" v-if="excelSablon && siparisList.models">
          <vs-button style="border-radius: 5px" variant="primary" v-on:click="siparisKaydet()"
            id="button-with-loading-cek" class="vs-con-loading__container">
            Sipariş Çek
          </vs-button>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card v-if="siparisList">
      <ag-grid-vue style="width: 100%; height: 400px; margin-top: 15px" class="ag-theme-alpine"
        :enableCellChangeFlash="true" :animateRows="true" :defaultColDef="defaultColDef" :columnDefs="columnDefs"
        :rowData="ordersList" :localeText="localeText" :suppressCopyRowsToClipboard="true" :pagination="true"
        @grid-ready="onGridReady">
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import state from "../../store/state";
import Store from "../../store/store";
import XLSX from "xlsx";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import { SiparisList, Siparis } from "../../models/SiparisList";
import { sanitizeText } from "../../helpers/sanitizeText";
import { fixTurkishCharsDeep } from "../../helpers/fixTurkishChars";

export default {
  data() {
    return {
      orderSource: "",
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: [],
      localeText: null,
      rowdata: null,
      siparisList: [],
      ordersList: [],
      parsedOrders: [{}],
      excelSablon: "",
      sablonOptions: [
        { value: "asr", name: "AsırGroup", excel: "AsirGroupOrnekSiparisSablon.xlsx" },
        { value: "evd", name: "Evidea", excel: "EvideaOrnekSiparisSablon.xlsx" },
        { value: "ruum", name: "RuumStore", excel: "RuumStoreOrnekSiparisSablon.xlsx" },
        { value: "vvs", name: "Vivense", excel: "VivenseOrnekSiparisSablon.xls" },
        { value: "dms", name: "LastBrand", excel: "LastBrandOrnekSiparisSablon.xlsx" },
        { value: "drp", name: "Dropshipping", excel: "Dropshipping.xlsx" },

        {
          value: "ord",
          name: "LastBrandTopluSiparis",
          excel: "LastBrandTopluSiparisOrnekSablon.xlsx",
        },
      ],
    };
  },
  components: {
    AgGridVue,
    vSelect,
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onChange(e) {
      const vm = this;
      var files = e.target.files,
        f = files[0];
      var reader = new FileReader();
      let orderNumber;

      if (this.excelSablon.value === "asr") {
        orderNumber = e.target.files[0].name.split("_")[1].split(".")[0];
      } else {
        orderNumber = e.target.files[0].name.split("_")[0];
      }
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array", cellDates: true });
        let sheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[sheetName];
        vm.ordersList = XLSX.utils.sheet_to_json(worksheet);
        vm.setItems(orderNumber);
      };
      reader.readAsArrayBuffer(f);
    },
    setItems(orderNumber) {
      let errorOrder = "";
      try {
        this.siparisList = new SiparisList();
        this.ordersList.forEach((val, index) => {
          errorOrder = index;
          console.log(val);
          if (this.excelSablon.value == "vvs") {
            let costumerName = val["Müşteri Adı"].split(" ");
            let firstName = "";
            costumerName.forEach((val, ind) => {
              if (ind != costumerName.length - 1) firstName += val;
            });
            this.siparisList.add([
              {
                orderNumber: val["Sipariş No"],
                order_Id: val["Web Sipariş Kodu"],
                page: "0",
                count: "0",
                program: this.excelSablon.name.trim(),
                productName: val["Ürün Adı"],
                productCode: "0",
                cargoProviderName: val["Kargo Firması"],
                cargoTrackingNumber: val["Kargo Takip No"],
                siparisTarihi: val["Sipariş Tarihi"],
                orderDate: val["Sipariş Tarihi"],
                lineId: val["Ürün Kodu"],
                shipFirstName: firstName,
                shipLastName: costumerName[costumerName.length - 1],
                shipFullName: val["Müşteri"],
                invoiceFirstName: firstName,
                invoiceLastName: costumerName[costumerName.length - 1],
                invoiceFullName: val["Müşteri"],
                shipAddress1: val["Müşteri Adresi"],
                shipAddress2: val["Müşteri Adresi"],
                shipCity: val["İl"],
                shipDistrict: val["İlçe"],
                shipFullAddress: val["Müşteri Adresi"],
                shipAddress1: val["Müşteri Adresi"],
                shipAddress2: val["Müşteri Adresi"],
                shipFullAddress: val["Müşteri Adresi"],
                invoiceAddress1: val["Müşteri Adresi"],
                invoiceAddress2: val["Müşteri Adresi"],
                invoiceFullAddress: val["Müşteri Adresi"],
                invoiceCity: val["İl"],
                invoiceDistrict: val["İlçe"],
                customerEmail: val["E-mail"],
                telefon: val["Telefon"],
                merchantSku: val["Ürün Kodu"],
                merchantId: val["Tedarikçi Kodu"],

                price: val["Alış"],
                totalPrice: parseFloat(val["Alış"]) * parseFloat(val["Adet"]),
                quantity: parseFloat(val["Adet"]),
                vatBaseAmount: "0",
                amount: parseFloat(val["Alış"]),
                grossAmount: parseFloat(val["Alış"]) * parseFloat(val["Adet"]),
              },
            ]);
          } else if (this.excelSablon.value == "ruum") {
            let costumerName = val["Müşteri"].split(" ");
            let firstName = "";
            costumerName.forEach((val, ind) => {
              if (ind != costumerName.length - 1) firstName += val;
            });
            this.siparisList.add([
              {
                orderNumber: val["Sipariş No"],
                page: "0",
                count: "0",
                program: this.excelSablon.name.trim(),
                productName: val["Ürün Adı"],
                productCode: val["Pazaryeri Kalem No"],
                productId: val["Pazaryeri Kalem No"],
                cargoProviderName: val["Kargo Firması"],
                cargoTrackingNumber: val["Kargo Takip No"],
                siparisTarihi: this.parseDate(val["Sipariş Tarihi"]),
                orderDate: this.parseDate(val["Sipariş Tarihi"]),
                lineId: val["Pazaryeri Kalem No"],
                shipFirstName: firstName,
                shipLastName: costumerName[costumerName.length - 1],
                shipFullName: val["Müşteri"],
                invoiceFirstName: firstName,
                invoiceLastName: costumerName[costumerName.length - 1],
                invoiceFullName: val["Müşteri"],
                shipAddress1: val["Teslim Adresi"],
                shipAddress2: val["Teslim Adresi"],
                shipCity: val["Şehir"],
                shipDistrict: val["İlçe"],
                shipFullAddress: val["Teslim Adresi"],
                shipAddress1: val["Teslim Adresi"],
                shipAddress2: val["Teslim Adresi"],
                shipCity: val["Şehir"],
                shipDistrict: val["İlçe"],
                shipFullAddress: val["Teslim Adresi"],
                invoiceAddress1: val["Teslim Adresi"],
                invoiceAddress2: val["Teslim Adresi"],
                invoiceFullAddress: val["Teslim Adresi"],
                invoiceCity: val["Şehir"],
                invoiceDistrict: val["İlçe"],
                customerEmail: val["E-mail"],
                telefon: val["Telefon"],
                merchantSku: "",
                merchantId: "",
                barcode: val["Tedarikçi Ürün Kodu"],

                price: val["Birim Fiyat (KDV Dahil)"],
                totalPrice:
                  parseFloat(val["Birim Fiyat (KDV Dahil)"]) * parseFloat(val["Miktar"]),
                quantity: parseFloat(val["Miktar"]),
                vatBaseAmount: parseFloat(val["KDV Oranı(%)"]),
                amount: parseFloat(val["Birim Fiyat (KDV Dahil)"]),
                grossAmount:
                  parseFloat(val["Birim Fiyat (KDV Dahil)"]) * parseFloat(val["Miktar"]),
              },
            ]);
          } else if (this.excelSablon.value == "evd") {
            this.siparisList.add([
              {
                orderNumber: val["Sipariş No"],
                page: "0",
                count: "0",

                program: this.excelSablon.name.trim(),
                productName: val["Stok Adı"],
                productCode: 0,

                siparisTarihi: val["Sipariş Tarihi"],
                orderDate: val["Son Kabul Tarihi"],
                lineId: val["Tedarikçi Kodu"],
                merchantSku: val["Stok Kodu"],
                merchantId: val["ÜRETİCİ STOK KODU"],
                sku: val["Tedarikçi Kodu"],
                barcode: val["Barkod"],

                price: val["Evidea Alış Fiyatı"],
                totalPrice:
                  parseFloat(val["Sipariş Miktarı"]) *
                  parseFloat(val["Evidea Alış Fiyatı"]),
                quantity: parseFloat(val["Sipariş Miktarı"]),
                vatBaseAmount: "0",
                amount: parseFloat(val["Toplam Tutar"]),
                alan8: parseFloat(val["Sevk Miktarı"]),
              },
            ]);
          } else if (this.excelSablon.value == "asr") {
            let today = moment(String(new Date())).format("YYYYMMDDHHss");
            this.siparisList.add([
              {
                orderNumber: orderNumber,
                page: "0",
                count: "0",
                program: this.excelSablon.name.trim(),
                productName: val["NAME"],
                productCode: "0",
                siparisTarihi: this.parseDate(new Date()),
                orderDate: this.parseDate(new Date()),
                lineId: val["ÜRETİCİ STOK KODU"],
                merchantSku: val["CODE"],
                merchantId: val["ÜRETİCİ STOK KODU"],
                sku: val["EAN CODE"],
                barcode: val["ÜRETİCİ BARKOD NO"],

                price: val["PRICE"],
                totalPrice: parseFloat(val["PRICE"]) * parseFloat(val["QUANTITY"]),
                quantity: parseFloat(val["QUANTITY"]),
                vatBaseAmount: "0",
                amount: parseFloat(val["PRICE"]),
                grossAmount: parseFloat(val["PRICE"]) * parseFloat(val["QUANTITY"]),
              },
            ]);
          } else if (this.excelSablon.value == "dms") {
            // let trackId = val["Tracking URL"].split("trackId=");
            let rawCustomer = val["Customer"] || "";
            let costumerName = "";
            let firstName = "";

            if (rawCustomer.includes(" ")) costumerName = rawCustomer.split(" ");
            else {
              firstName = rawCustomer;
              costumerName = rawCustomer;
            }
            if (Array.isArray(costumerName)) {
              costumerName.forEach((val, ind) => {
                if (ind != costumerName.length - 1) firstName += val;
              });
            } else firstName = costumerName

            // Yeni excelde adres Address 1/2, City, State/Province, Zip Code kolonlarında
            // geliyor; eski excellerde tek kolon olan "Shipping Destination" kullanılıyordu.
            let addressLine = [val["Address 1"], val["Address 2"]]
              .filter(Boolean)
              .join(" ")
              .trim();
            let fullAddress = [
              addressLine,
              val["City"],
              val["State/Province"],
              val["Zip Code"],
              val["Country"],
            ]
              .filter(Boolean)
              .join(", ");

            if (!addressLine) {
              addressLine = val["Shipping Destination"] || "";
              fullAddress = val["Shipping Destination"] || "";
            }

            this.siparisList.add([
              {
                orderNumber: val["Order Number"] + "-" + val["Cargo Number"],
                page: "0",
                count: "0",
                program: this.excelSablon.name.trim(),
                productName: val["Product Title"],
                productColor: val["Variant Title"],
                cargoProviderName: val["Tracking URL"],
                cargoTrackingNumber: val["Cargo Number"],
                siparisTarihi: this.parseDate(val["Purchase Date"]),
                orderDate: this.parseDate(val["Purchase Date"]),
                productCode: 0,
                vatBaseAmount: "0",
                merchantSku: "",
                merchantId: "",
                shipFirstName: sanitizeText(firstName),
                shipFullName: sanitizeText(rawCustomer),
                shipLastName: sanitizeText(costumerName[costumerName.length - 1]),

                invoiceFirstName: sanitizeText(firstName),
                invoiceLastName: sanitizeText(costumerName[costumerName.length - 1]),
                invoiceFullName: sanitizeText(rawCustomer),

                shipAddress1: val["Address 1"] || addressLine,
                shipAddress2: val["Address 2"] || "",
                shipFullAddress: fullAddress,
                shipCity: val["City"] || "",
                shipDistrict: val["State/Province"] || "",
                shipPostalCode: val["Zip Code"] ? String(val["Zip Code"]) : "",
                shipCountryCode: val["Country"] || "",

                invoiceAddress1: val["Address 1"] || addressLine,
                invoiceAddress2: val["Address 2"] || "",
                invoiceFullAddress: fullAddress,
                invoiceCity: val["City"] || "",
                invoiceDistrict: val["State/Province"] || "",
                invoicePostalCode: val["Zip Code"] ? String(val["Zip Code"]) : "",
                invoiceCountryCode: val["Country"] || "",

                sku: val["SKU"],
                merchantId: "",

                price: 0,
                totalPrice: 0,
                quantity: parseFloat(val["Quantity"]),
                vatBaseAmount: 0,
                amount: 0,
                grossAmount: 0,
              },
            ]);
          } else if (this.excelSablon.value == "ord") {
            this.siparisList.add([
              {
                program: this.excelSablon.name.trim(),
                orderNumber: val["Sipariş No"],
                sku: val["SKU"],
                productName: val["Product"],
                productColor: val["Color"],
                productSize: val["Beden"],
                quantity: parseFloat(val["Eklenecek Adet"]),
              },
            ]);
          } else if (this.excelSablon.value == "drp") {
          console.log(val);

          let costumerName = (val["Alıcı Ad Soyad"] || "").split(" ");
          let firstName = "";

          costumerName.forEach((v, ind) => {
            if (ind != costumerName.length - 1) firstName += v + " ";
          });

          let invoiceCostumerName = (val["Fatura Ad Soyad"] || "").split(" ");
          let invoiceFirstName = "";

          invoiceCostumerName.forEach((v, ind) => {
            if (ind != invoiceCostumerName.length - 1) invoiceFirstName += v + " ";
          });

          this.siparisList.add([
            {
              orderNumber: val["Sipariş Numarası"] || "",
              program: val["Pazaryeri"] || "",

              siparisTarihi: val["Sipariş Tarihi"]
                ? this.parseDate(val["Sipariş Tarihi"])
                : "",

              orderDate: val["Sipariş Tarihi"]
                ? this.parseDate(val["Sipariş Tarihi"])
                : "",

              cargoProviderName: val["Kargo Firması"] || "",
              cargoTrackingNumber: val["Kargo Kodu"] || "",

              shipFirstName: firstName.trim(),
              shipLastName: costumerName.length > 0 ? costumerName[costumerName.length - 1] : "",

              shipAddress1: val["Teslimat Adresi"] || "",
              shipAddress2: val["Teslimat Adresi"] || "",
              shipFullAddress: val["Teslimat Adresi"] || "",

              shipCity: val["Teslimat İl"] || "",
              shipDistrict: val["Teslimat İlçe"] || "",

              invoiceFullName: val["Fatura Ad Soyad"] || "",
              invoiceFirstName: invoiceFirstName.trim(),
              invoiceLastName:
                invoiceCostumerName.length > 0
                  ? invoiceCostumerName[invoiceCostumerName.length - 1]
                  : "",

              invoiceCity: val["Fatura İl"] || "",
              invoiceDistrict: val["Fatura İlçe"] || "",

              invoiceFullAddress: val["Fatura Adresi"] || "",
              invoiceAddress1: val["Fatura Adresi"] || "",
              invoiceAddress2: val["Fatura Adresi"] || "",

              shipPostalCode: val["Posta Kodu"] || "",

              tcIdentityNumber: val["Tc Kimlik No"] || "",
              taxNumber: val["Vergi Numarası"] || "",
              taxOffice: val["Vergi Dairesi"] || "",

              customerEmail: val["E-mail"] || "",
              telefon: val["Telefon"] || "",

              merchantSku: val["Satıcı Stok Kodu/Barkodu"] || "",
              barcode: val["Barkod"] || "",
              sku: val["Stok Kodu"] || "",

              productName: val["Ürün Adı"] || "",

              quantity: val["Adet"] ? parseFloat(val["Adet"]) : 0,

              kapıdaOdeme: val["Kapıda Ödeme"] || false,

              price: val["Fiyat"] || 0,
              discount: val["İndirim"] || 0,
              kargoTutari: val["Kargo Tutarı"] || 0,
              totalPrice: val["Toplam"] || 0,

              page: "0",
              count: "0",

              productCode: val["productCode"] || 0,

              siparisKaynagi: "Dropshipping",

              vatBaseAmount: val["vatBaseAmount"] || 0,
              amount: val["amount"] || 0,
              grossAmount: val["grossAmount"] || 0,
            },
          ]);
        }
        });
        console.log(this.siparisList);
        this.columnDefs = [];
        let list = this.ordersList[0];
        let columnList = Object.keys(list);
        if (this.excelSablon.value == "drp") {
          this.columnDefs = this.columnDefsDrp;
        } else {
          columnList.forEach((val, index) => {
            if (val !== "Resim") {
              this.columnDefs.push({
                field: val,
                filter: "agSetColumnFilter",
                wrapText: true,
                autoHeight: true,
              });
            }
          });
        }
        console.log(this.columnDefs);
      } catch (error) {
        var vs = this.$vs;
        vs.notify({
          text:
            "Excel formatınızın doğruluğundan emin olun. Hata Satırı: " +
            (parseInt(errorOrder) + 2),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
        console.log(error);
      }
    },
    parseDate(params) {
      if (params === null || params === undefined || params === "") return "";

      // Excel cellDates:true -> Date nesnesi; bazen düz metin ya da seri sayı gelebilir
      if (params instanceof Date) {
        const m = moment(params);
        return m.isValid() ? m.format("YYYY-MM-DD") : "";
      }

      // Excel seri sayısı (ör. 46217) -> tarihe çevir
      if (typeof params === "number" || /^\d+$/.test(String(params).trim())) {
        const serial = Number(params);
        const m = moment(new Date(Math.round((serial - 25569) * 86400 * 1000)));
        if (m.isValid()) return m.format("YYYY-MM-DD");
      }

      const str = String(params).trim();
      const formats = [
        moment.ISO_8601,
        "DD.MM.YYYY HH:mm:ss",
        "DD.MM.YYYY HH:mm",
        "DD.MM.YYYY",
        "DD/MM/YYYY",
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DD",
      ];
      let m = moment(str, formats, true);
      if (!m.isValid()) m = moment(new Date(str)); // son çare: JS Date fallback
      return m.isValid() ? m.format("YYYY-MM-DD") : "";
    },
    siparisKaydet() {
      var vs = this.$vs;
      let type = "material";
      vs.loading({
        container: "#button-with-loading-cek",
        type,
      });
      let argsSipList = [];
      this.siparisList.models.forEach((val, ind) => {
        argsSipList.push(val._attributes);
      });
      var jsonConvertargs = JSON.stringify(argsSipList);
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        orders: jsonConvertargs,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.excelSiparisCek(args, function (err, result) {
          if (result.excelSiparisCekResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            var vm = this;
            let veriler = fixTurkishCharsDeep(JSON.parse(result.excelSiparisCekResult));
            if (veriler.response == "Ok") {
              vs.loading.close("#button-with-loading-cek > .con-vs-loading");
              vs.notify({
                text: veriler.mesaj,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } else {
              vs.loading.close("#button-with-loading-cek > .con-vs-loading");
              vs.notify({
                text: veriler.mesaj,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-cek > .con-vs-loading");
            console.log(error);
            vs.notify({
              text: "Başarısız",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    const dict = {
      custom: {
        name: {
          required: "Excel şablon adı gereklidir",
        },
      },
    };
    Validator.localize("en", dict);
  },
  beforeMount() {
    this.columnDefsDrp = [
      {
        field: "Sipariş Numarası",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Pazaryeri",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Sipariş Tarihi",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Kargo Firması",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Kargo Kodu",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Alıcı Ad Soyad",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Teslimat Adresi",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Teslimat İl",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Teslimat İlçe",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Fatura Ad Soyad",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Fatura Adresi",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Fatura İl",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Fatura İlçe",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Posta Kodu",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Tc Kimlik No",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Vergi Numarası",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Vergi Dairesi",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "E-mail",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Telefon",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Satıcı Stok Kodu/Barkodu",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Barkod",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Stok Kodu",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Ürün Adı",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Adet",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Kapıda Ödeme",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Fiyat",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "İndirim",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Kargo Tutarı",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
      {
        field: "Toplam",
        filter: "agSetColumnFilter",
        wrapText: true,
        autoHeight: true,
      },
    ];
  },
};
</script>
